import { render, staticRenderFns } from "./SwLoader.vue?vue&type=template&id=1816c677&scoped=true"
import script from "./SwLoader.vue?vue&type=script&lang=js"
export * from "./SwLoader.vue?vue&type=script&lang=js"
import style0 from "./SwLoader.vue?vue&type=style&index=0&id=1816c677&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1816c677",
  null
  
)

export default component.exports